import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ProductoService } from '../producto.service';
import { AlertService, LoadingService } from 'ngx-kuv-tools';
import { FormatterService } from 'src/app/utils/formatter/formatter.service';
import { ConfigService } from 'src/app/utils/config/config.service';

@Component({
  selector: 'app-producto-historial',
  templateUrl: './producto-historial.component.html',
  styleUrls: ['./producto-historial.component.scss']
})
export class ProductoHistorialComponent implements OnInit {
  id!: number
  tableItems: any[] = [];
  columnas: any[] = [
    {
      label: "Fecha",
      attribute: "fecha",
      responsive: ['XS', 'SM', 'MD'],
      value: (el: any) => {
        return this.formatter.dateFormat(el.fecha)
      }

    },
    {
      label: "Tipo Fuente",
      attribute: "tipo_fuente",
      responsive: ['XS', 'SM', 'MD']

    },
    {
      label: "Motivo",
      attribute: "motivo",
      responsive: ['XS', 'SM', 'MD'],

    }
  ]
  constructor(
    public config: ConfigService,
    public formatter: FormatterService,
    private loading: LoadingService,
    private alerts: AlertService,
    private modalService: NgbModal,
    public service: ProductoService,
    public activeModal: NgbActiveModal,) { }

  ngOnInit(): void {
    this.id = this.service.id;
    this.historial(this.id)
  }
  historial(id: any) {
    this.loading.show()
    this.service.historial_stock(id).subscribe({
      next: (res: any) => {
        this.loading.hide();
        this.tableItems = res

      }, error: (err: any) => {
        this.loading.hide();
        if (err.response) this.alerts.addAlert(err.response, 'danger');
      }
    });
  }
}
